import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import ScrollToTopOnRouteChange from './ScrollToTopOnRouteChange';
import Inicio from '../pages/Inicio';
import Contact from '../pages/Contact';
import Footer from './Footer';
import About from '../pages/About';
import Gallery from '../pages/Gallery';
import AlquilerMobiliario from '../pages/AlquilerMobiliario';
import CreacionStands from '../pages/CreacionStands';
import PantallasTactiles from '../pages/PantallasTactiles';
import PantallasSolucionesInteractivas from '../pages/PantallasSolucionesInteractivas';
import AdminDashboard from '../pages/AdminDashboard';
import TrabajoDetalle from '../pages/TrabajoDetalle';
import EasyClick from '../pages/EasyClick';
import Clientes from '../pages/Clientes';
import Productos from '../pages/Productos.js';
import Carteleria from '../pages/Carteleria.js';
import WhatsAppButton from './WhatsAppButton.js';
import PageSeo from './PageSeo';
import AnalyticsTracker from './AnalyticsTracker';
import legacyRedirects from '../config/legacyRedirects.json';


function UserNavBar() {
  const { t } = useTranslation();
  const [isSidebarOpen, setSidebarOpen] = React.useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Menu states

  const [isMobileSolutionsOpen, setMobileSolutionsOpen] = useState(false);
  const [isDesktopSolutionsOpen, setDesktopSolutionsOpen] = useState(false);

  function toggleSidebar() {
    setSidebarOpen(prev => !prev);
    setIsActive(!isActive);
  }

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 10) {
        setIsHeaderVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setIsHeaderVisible(false);
      } else {
        setIsHeaderVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <>
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src="/LogoExhibirte.png" alt="Exhibirte" className="sidebar-logo" />
        </div>
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link to="/" onClick={toggleSidebar} className="nav-link">{t('nav.home')}</Link>
          </li>

          <li className="nav-item">
            <button
              type="button"
              className="nav-link d-flex justify-content-between align-items-center"
              onClick={() => setMobileSolutionsOpen((isOpen) => !isOpen)}
              aria-expanded={isMobileSolutionsOpen}
            >
              {t('nav.solutions')}
              <span className="submenu-icon">
                {isMobileSolutionsOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
              </span>
            </button>
            <div className={`submenu-container ${isMobileSolutionsOpen ? 'open' : ''}`} style={{ maxHeight: isMobileSolutionsOpen ? '1000px' : '0', overflow: 'hidden', transition: 'max-height 0.4s ease-in-out' }}>
              <ul className="submenu" style={{ listStyle: 'none', paddingLeft: '20px', backgroundColor: 'rgba(255,255,255,0.05)', margin: 0 }}>
                <li><Link to="/diseno-fabricacion-stands" onClick={toggleSidebar} className="nav-link">{t('nav.stands')}</Link></li>
                <li><Link to="/alquiler-mobiliario-eventos" onClick={toggleSidebar} className="nav-link">{t('nav.furniture')}</Link></li>
                <li><Link to="/servicios/carteleria" onClick={toggleSidebar} className="nav-link">{t('nav.signage_exhibition')}</Link></li>
                <li><Link to="/pantallas-soluciones-interactivas" onClick={toggleSidebar} className="nav-link">{t('nav.led_screens')}</Link></li>
              </ul>
            </div>
          </li>
          <li className="nav-item">
            <Link to="/capacidades-produccion" onClick={toggleSidebar} className="nav-link">{t('nav.capabilities')}</Link>
          </li>
          <li className="nav-item">
            <Link to="/proyectos" onClick={toggleSidebar} className="nav-link">{t('nav.projects')}</Link>
          </li>
          <li className="nav-item">
            <Link to="/clientes" onClick={toggleSidebar} className="nav-link">{t('nav.clients')}</Link>
          </li>
          <li className="nav-item">
            <Link to="/nosotros" onClick={toggleSidebar} className="nav-link">{t('nav.about')}</Link>
          </li>
          <li className="nav-item">
            <Link to="/contacto" onClick={toggleSidebar} className="nav-link">{t('nav.contact')}</Link>
          </li>
        </ul>
      </div>

      <header className={`header-scroll ${isHeaderVisible ? 'header-visible' : 'header-hidden'}`}>
        <div className="header">
          <div className="header-left">
            <Link to="/" style={{ fontWeight: 'bold', fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/LogoExhibirte.png" alt="Exhibirte" onError={(e) => e.target.style.display = 'none'} />
            </Link>
          </div>
          <nav className="desktop-navigation" aria-label={t('nav.primaryNavigation')}>
            <Link to="/" className="desktop-nav-link">{t('nav.home')}</Link>
            <div
              className="desktop-nav-group"
              onMouseEnter={() => setDesktopSolutionsOpen(true)}
              onMouseLeave={() => setDesktopSolutionsOpen(false)}
            >
              <button
                type="button"
                className="desktop-nav-link desktop-nav-dropdown-toggle"
                onClick={() => setDesktopSolutionsOpen((isOpen) => !isOpen)}
                aria-expanded={isDesktopSolutionsOpen}
              >
                {t('nav.solutions')} <FaChevronDown size={10} aria-hidden="true" />
              </button>
              {isDesktopSolutionsOpen && (
                <div className="desktop-nav-dropdown">
                  <Link to="/diseno-fabricacion-stands" onClick={() => setDesktopSolutionsOpen(false)}>{t('nav.stands')}</Link>
                  <Link to="/alquiler-mobiliario-eventos" onClick={() => setDesktopSolutionsOpen(false)}>{t('nav.furniture')}</Link>
                  <Link to="/servicios/carteleria" onClick={() => setDesktopSolutionsOpen(false)}>{t('nav.signage_exhibition')}</Link>
                  <Link to="/pantallas-soluciones-interactivas" onClick={() => setDesktopSolutionsOpen(false)}>{t('nav.led_screens')}</Link>
                </div>
              )}
            </div>
            <Link to="/capacidades-produccion" className="desktop-nav-link">{t('nav.capabilities')}</Link>
            <Link to="/proyectos" className="desktop-nav-link">{t('nav.projects')}</Link>
            <Link to="/clientes" className="desktop-nav-link">{t('nav.clients')}</Link>
            <Link to="/nosotros" className="desktop-nav-link">{t('nav.about')}</Link>
          </nav>
          <div className="header-right d-flex justify-content-between align-items-center gap-2">
            <Link to="/contacto" className="header-contact-link">{t('nav.contact')}</Link>
            <div className={`burger-menu ${isActive ? 'active' : ''}`} onClick={toggleSidebar}>
              <div className="line"></div>
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<AdminDashboard />} />
    </Routes>
  );
}

// Server redirects handle direct visits; this also supports old links inside the SPA.
function LegacyRedirect({ to }) {
  const { search, hash } = useLocation();
  const [destination, fragment] = to.split('#');
  return <Navigate replace to={`${destination}${search}${fragment ? `#${fragment}` : hash}`} />;
}

function UserRoutes() {
  return (
    <div className="main-content">
      <PageSeo />
      <AnalyticsTracker />
      <UserNavBar />
      <Routes>
        {Object.entries(legacyRedirects).map(([from, to]) => (
          <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
        ))}
        <Route path="/" element={<Inicio />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/nosotros" element={<About />} />
        <Route path="/proyectos" element={<Gallery />} />
        <Route path="/trabajo/:id" element={<TrabajoDetalle />} />

        {/* New Menu Pages */}
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/capacidades-produccion" element={<Productos />} />

        {/* Service Pages */}
        <Route path="/alquiler-mobiliario-eventos" element={<AlquilerMobiliario />} />
        <Route path="/diseno-fabricacion-stands" element={<CreacionStands />} />
        <Route path="/pantallas-soluciones-interactivas" element={<PantallasSolucionesInteractivas />} />
        <Route path="/pantallas-tactiles" element={<PantallasTactiles />} />
        <Route path="/exhibidores-modulares-easyclick" element={<EasyClick />} />
        <Route path="/servicios/carteleria" element={<Carteleria />} />
      </Routes>
      <Footer />
    </div>
  );
}



function Rutas() {
  return (
    <div id="app-root">
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTopOnRouteChange />
        <WhatsAppButton />
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/*" element={<UserRoutes />} />
        </Routes>
      </Router>
    </div>
  );
}

export default Rutas;

